import { render, staticRenderFns } from "./BundleSelect.vue?vue&type=template&id=58a226c5&scoped=true&"
import script from "./BundleSelect.vue?vue&type=script&lang=js&"
export * from "./BundleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a226c5",
  null
  
)

export default component.exports